import TitleCell from "../common/List/TitleCell";
import UserRow from "./UserRow";
import List from "../common/List/List";

import uniqid from "uniqid";
import { useState } from "react";
import UserPopUp from "./UserPopUp";

const UserList = ({ users, setUsers, setRefetchUser }) => {
  const titles = [
    "會員編號",
    "姓名",
    "聯絡電話",
    "身分",
    "身分證",
    "職業",
    "Line 帳號",
    "房號",
    "租期",
    "備註",
  ];
  const [curUser, setCurUser] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false);

  return (
    <div>
      {showPopUp ? (
        <UserPopUp
          user={curUser}
          setUsers={setUsers}
          setShowPopUp={setShowPopUp}
          users={users}
          setRefetchUser={setRefetchUser}
        />
      ) : (
        <></>
      )}
      <List gridCols="grid-cols-[repeat(9,min-content)_1fr]">
        {titles.map((title) => (
          <TitleCell
            key={uniqid()}
            className="whitespace-nowrap px-2 overflow-x-auto"
            text={title}
          />
        ))}
        {users.map((user) => (
          <UserRow
            key={uniqid()}
            user={user}
            setShowPopUp={setShowPopUp}
            setCurUser={setCurUser}
          />
        ))}
      </List>
    </div>
  );
};

export default UserList;
